import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import News from "./pages/News";
import Gallery from "./pages/Gallery";
import Videos from "./pages/Videos";
import Sports from "./pages/Sports";
import Login from "./components/Login";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Worksheets from "./pages/Worksheets";
import Scholarships from "./pages/Scholarships";
import Home from "./pages/Home";
import DashBoard from "./components/DashboardComponents/Index";
import Layout from "./pages/Layout";
import UserWidgets from "./components/DashboardComponents/UserWidgets";
import "./App.css";
import EditAbout from "./components/DashboardComponents/AboutComponent/EditAbout";
import EditContact from "./components/DashboardComponents/ContactComponent/EditContact";
import EditFlashNews from "./components/DashboardComponents/FlashNewsComponent/EditFlashNews";
import EditHomePage from "./components/DashboardComponents/HomePageComponent/EditHomePage";
import EditImage from "./components/DashboardComponents/UploadImageComponent/UploadNews";
import UploadSlides from "./components/DashboardComponents/UploadSlideComponent/UploadSlides";
import HeaderImageUploader from "./components/DashboardComponents/HeaderImageUploadComponent/HeaderImageUploader";
import PdfUploader from "./components/DashboardComponents/PdfUploadComponent/PdfUploader";
import LinkUploader from "./components/DashboardComponents/LinkUploadComponent/LinkUploader";
import ScrollingMessage from "./components/DashboardComponents/ScrollingMsgComponent/ScrollingMessage";
import useGlobalAppContext from "./hooks/useGlobalAppContext";
import PageNotFound from "./pages/PageNotFound";
import UploadNews from "./components/DashboardComponents/UploadImageComponent/UploadNews";
const App = () => {
  const [auth, setAuth] = useState(() => {
    const storedAuth = localStorage.getItem("auth");
    return storedAuth ? JSON.parse(storedAuth) : true;
  });

  const [role, setRole] = useState(() => {
    return localStorage.getItem("role") || "admin";
  });

  const [userdata, setUserData] = useState(() => {
    const storedUser = localStorage.getItem("userdata");
    return storedUser ? JSON.parse(storedUser) : { username: "kkcc" };
  });

  // Update localStorage when states change
  useEffect(() => {
    localStorage.setItem("auth", JSON.stringify(auth));
  }, [auth]);

  useEffect(() => {
    localStorage.setItem("role", role);
  }, [role]);

  useEffect(() => {
    localStorage.setItem("userdata", JSON.stringify(userdata));
  }, [userdata]);
  const store = { auth, setAuth, role, setRole, userdata, setUserData };
  return (
    <useGlobalAppContext.Provider value={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/news" element={<News />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/scholoships" element={<Scholarships />} />
            <Route path="/worksheets" element={<Worksheets />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/aboutus" element={<AboutUs />} />
            {/* <Route path="/login" element={<DashBoard />} /> */}
          </Route>
          {auth && (
            <Route
              path="/dashboard"
              element={
                <DashBoard
                // setAuth={setAuth}
                // setRole={setRole}
                // setUserData={setUserData}
                />
              }
            >
              <Route index element={<UserWidgets />} />
              <Route path="/dashboard/flash-news" element={<EditFlashNews />} />
              <Route
                path="/dashboard/scrolling-message"
                element={<ScrollingMessage />}
              />

              <Route
                path="/dashboard/home-page-data"
                element={<EditHomePage />}
              />
              <Route path="/dashboard/about-data" element={<EditAbout />} />
              <Route path="/dashboard/contact-data" element={<EditContact />} />
              <Route path="/dashboard/upload-gallary" element={<EditImage />} />
              <Route path="/dashboard/upload-news" element={<UploadNews />} />
              <Route
                path="/dashboard/upload-slide"
                element={<UploadSlides />}
              />
              <Route
                path="/dashboard/upload-header-image"
                element={<HeaderImageUploader />}
              />
              <Route path="/dashboard/upload-pdf" element={<PdfUploader />} />
              <Route
                path="/dashboard/upload-links"
                element={<LinkUploader />}
              />
            </Route>
          )}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </useGlobalAppContext.Provider>
  );
};

export default App;
